import { Button } from '@progress/kendo-react-buttons';
import { GridCellProps } from '@progress/kendo-react-grid';
import { truncateString } from 'common/hooks/utils';
import { useState } from 'react';

function TextCell(props: GridCellProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const { dataItem, field } = props;

  if (typeof dataItem[field ?? ''] !== 'string') {
    return <td>{dataItem[field ?? '']}</td>;
  }

  const rawValue = dataItem[field ?? ''];
  let text = '';
  if (Array.isArray(rawValue)) {
    text = rawValue.join(', ');
  } else {
    text = rawValue ?? '';
  }
  const textLength = 200;

  const truncatedText = text.length > textLength ? truncateString(text, textLength) : undefined;

  return (
    <td>
      <p className="">{truncatedText && !isExpanded ? truncatedText : text}</p>
      {truncatedText && (
        <Button
          size="small"
          fillMode="link"
          className="expand-button"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? 'Collapse' : 'Expand'}
        </Button>
      )}
    </td>
  );
}

export default TextCell;
